import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader } from "lucide-react";
import { useStaffAuth } from "./StaffAuth";

export default function StaffLogin() {
  const { login } = useStaffAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/staff");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Invalid email or password.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-shell" data-testid="staff-login">
      <form onSubmit={submit} className="auth-card" style={{ gap: 16 }}>
        <Lock size={22} />
        <p className="eyebrow">Zorba Staff</p>
        <h1>Sign in to the staff portal</h1>
        <p className="muted">
          For front-desk and spa staff only. Use the email and password you were given on your first shift.
        </p>
        <label style={{ display: "grid", gap: 6, fontSize: 12, fontWeight: 700 }}>
          Email
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="staff-email"
            style={{ padding: "11px 12px", border: "1px solid var(--line)", borderRadius: 4 }}
          />
        </label>
        <label style={{ display: "grid", gap: 6, fontSize: 12, fontWeight: 700 }}>
          Password
          <input
            type="password"
            required
            minLength={4}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="staff-password"
            style={{ padding: "11px 12px", border: "1px solid var(--line)", borderRadius: 4 }}
          />
        </label>
        {err && <p className="form-error" data-testid="staff-login-error">{err}</p>}
        <button type="submit" className="btn btn-primary full" disabled={busy} data-testid="staff-login-submit">
          {busy ? <><Loader size={14} className="spin" /> Signing in…</> : "Sign in"}
        </button>
        <p className="muted-small">
          Lost your password? Ask the manager to rotate it in <code>STAFF_SEED_PASSWORD</code>.
        </p>
      </form>
    </div>
  );
}
